import { Link } from 'react-router-dom';
import { Card, Layout, Menu, Space } from 'antd';
import {
  HomeOutlined,
  FileTextOutlined,
  ToolOutlined,
  FileProtectOutlined,
  UnorderedListOutlined,
  ContainerOutlined,
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import './menu-sider.scss';
import CanShow from '../../can-show';
import { useUser } from '../../../hooks';
import { useQuery } from '@tanstack/react-query';
import { Customer, get } from '../../../api';

const MenuSider = ({
  menuCollapsed,
  roles = [],
}: {
  menuCollapsed: boolean | undefined;
  roles: string[];
}) => {
  const { Sider } = Layout;
  const location = useLocation();
  const { user } = useUser();
  //ENDPOINTS
  const { isLoading: isLoadingUser, data: customer } = useQuery<Customer>(
    ['customer'],
    () => get<Customer>('/customers/' + user?.customer_id).then((e) => e.data)
  );

  return (
    <Sider
      className="admin-sider"
      collapsed={menuCollapsed}
      collapsible
      breakpoint="md"
      collapsedWidth="0"
      width={220}
      style={{ position: 'fixed' }}
    >
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item key="/">
          <Link to="/">
            <HomeOutlined />
            <span className="nav-text">Inicio</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/facturacion">
          <Link to="/facturacion">
            <FileProtectOutlined />
            <span className="nav-text">Facturación</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/antiguedad-saldos">
          <Link to="/antiguedad-saldos">
            <FileTextOutlined />
            <span className="nav-text">Antigüedad de saldos</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/orders">
          <Link to="/orders">
            <ContainerOutlined />
            <span className="nav-text">Órdenes</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/administration">
          <CanShow roles={['Admin']}>
            <Link to="/administration">
              <ToolOutlined />
              <span className="nav-text">Administración</span>
            </Link>
          </CanShow>
        </Menu.Item>
        <Menu.Item key="/catalogs">
          <CanShow roles={['Admin']}>
            <Link to="/catalogs">
              <UnorderedListOutlined />
              <span className="nav-text">Catálogos</span>
            </Link>
          </CanShow>
        </Menu.Item>
        <CanShow roles={['Customer']}>
          <>
            <Space direction="vertical" size={10} className="space-complete">
              {/* <Card
                headStyle={{ color: 'rgba(255, 255, 255, 0.65)' }}
                size="small"
                title="Ejecutivo de cobranza"
                className="agent-card"
              >
                <p>Nombre: {customer?.sales_agent_name}</p>
                <p>Teléfono: {customer?.sales_agent_phone}</p>
                <p>Correo: {customer?.sales_agent_email}</p>
              </Card> */}
              <Card
                headStyle={{ color: 'rgba(255, 255, 255, 0.65)' }}
                size="small"
                title="Agente de ventas"
                className="agent-card"
              >
                <p>Nombre: {customer?.sales_agent_name}</p>
                <p>Teléfono: {customer?.sales_agent_phone}</p>
                <p>Correo: {customer?.sales_agent_email}</p>
              </Card>
            </Space>
          </>
        </CanShow>
      </Menu>
    </Sider>
  );
};

export default MenuSider;
